/* src/app/components/natPay/payroll-nat-pay-details/payroll-nat-pay-detail.component.css */
.table-style {
  width: 100%;
}
#fileTriagePreviewHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#fileTriagePreview .actions-container {
  padding-bottom: 1rem;
  display: flex;
}
#fileTriagePreview .actions-container div {
  margin-right: 0;
  margin-left: auto;
  display: flex;
}
/*# sourceMappingURL=payroll-nat-pay-detail.component-UP6MC527.css.map */
